<template>
  <TimeEntriesBaseSelectFilter
    class="time-type-filter"
    label="Time Type"
    placeholder="All types"
    :options="timeTypeOptions"
    query-property="time_types"
    multiple
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesTimeTypeFilter',
  computed: {
    ...mapGetters(['timeTypeOptions']),
  },
};
</script>
